import qs from "query-string";

export default function normalizeRouteQuery({ wildcard, ...params }) {
  const query = qs.stringify(params);
  return query ? `?${query}` : "";
}
